import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { getCoreWiseDistribution, getYourImpacts } from '../apis/user/user';
import { useLoadingState } from './useLoader';

export const useImpacts = () => {
    const [yourImpacts, setYourImpacts] = useState([]);
    // const [loading, startLoading, stopLoading] = useLoadingState();
    const [coreWiseDistribution, setCoreWiseDistribution] = useState([]);
    const { state } = useContext(AuthContext);
    const { user } = state;
    const userProfile = user[0];

    useEffect(function () {
        const fetchData = async () => {
            try {
                // startLoading();
                const [response1, response2] = await Promise.all([
                    getYourImpacts(userProfile?.uid),
                    getCoreWiseDistribution(),
                ]);
                setYourImpacts(response1);
                setCoreWiseDistribution(response2);
            } catch (error) {
                console.error(error, 'erroe');
            } finally {
                // stopLoading();
            }
        };
        fetchData();
    }, []);
    return [yourImpacts, coreWiseDistribution];
};
